import { SnowflakeAlertIcon } from './SnowflakeAlertIcon';

/**
 * author: Michael Irigoyen
 * id 5F856EA3-F987-439D-AAFF-ED545ECBBA75
 * name snowflake-alert
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/snowflake-alert.svg
 * tags
 * - Weather 
 * - Alert / Error 
 * - Home Automation 
 */
export const ColdAlertIcon = SnowflakeAlertIcon;
export default ColdAlertIcon